import React from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';

const OpeningTimes = ({ footer }) => {
  return (
    <>
      {footer ? (
        <h1 className="text-2xl font-Poppins">Öffnungszeiten</h1>
      ) : (
        <h1 className="text-4xl py-2 font-Poppins font-semibold">
          {' '}
          Öffnungs<span className="text-primary">zeiten</span>{' '}
        </h1>
      )}
      <ul className="w-full max-w-[250px] py-4 space-y-2 text-center">
        <li className="flex items-center justify-between">
          <div className="flex items-center">
            <i className="fas fa-clock text-primary mr-2"></i>
            <span>Mo - Do:</span>
          </div>
          <span className="ml-auto text-green-700">
            09:00 - 14:00 Uhr
          </span>
        </li>
        <li className="flex items-center justify-between">
          <div className="flex items-center">
            <i className="fas fa-clock text-primary mr-2"></i>
            <span>Fr:</span>
          </div>
          <span className="ml-auto text-green-700">
            09:00 - 13:00 Uhr
          </span>
        </li>
        <li className="flex items-center justify-between">
          <div className="flex items-center">
            <i className="fas fa-clock text-primary mr-2"></i>
            <span>Sa - So:</span>
          </div>
          <span className="ml-auto text-red-600">Geschlossen</span>
        </li>
      </ul>
    </>
  );
};

export default OpeningTimes;
